import { StandardEvents } from '@shopify/events';

const quoteDialog = document.querySelector('#scg-quote-dialog');
const textDialog = document.querySelector('#scg-textus-dialog');
const textWrap = document.querySelector('[data-scg-textus]');
if (textWrap && sessionStorage.getItem('scg-textus-dismissed')) textWrap.classList.add('scg-textus--compact');
document.addEventListener('click', event => {
  if (event.target.closest('[data-scg-textus-dismiss]')) { event.stopPropagation(); textWrap?.classList.add('scg-textus--compact'); try { sessionStorage.setItem('scg-textus-dismissed', '1'); } catch {} return; }
  if (event.target.closest('[data-scg-textus-open]')) textDialog?.showModal();
  if (event.target.closest('[data-scg-textus-close]')) textDialog?.close();
  if (event.target.closest('[data-scg-quote-open]') && textDialog?.open) textDialog.close();
}, true);
textDialog?.addEventListener('click', event => { if (event.target === textDialog) textDialog.close(); });
document.addEventListener('click', event => {
  if (event.target.closest('[data-scg-quote-open]')) quoteDialog?.showModal();
  if (event.target.closest('[data-scg-quote-close]')) quoteDialog?.close();
});
quoteDialog?.addEventListener('click', event => { if (event.target === quoteDialog) quoteDialog.close(); });

let cartController;
async function updateSquadCartSummary() {
  cartController?.abort();
  cartController = new AbortController();
  const elements = document.querySelectorAll('[data-scg-cart-summary]');
  if (!elements.length) return;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { signal: cartController.signal, headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    elements.forEach(element => {
      element.querySelector('[data-scg-cart-count]').textContent = cart.item_count;
      element.querySelector('[data-scg-cart-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: cart.currency || element.dataset.currency || 'AUD', currencyDisplay: 'code' }).format(cart.total_price / 100);
    });
  } catch (error) { if (error.name !== 'AbortError') console.warn('Cart summary could not refresh.', error); }
}
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  if (event.promise) event.promise.then(updateSquadCartSummary).catch(() => {});
  else updateSquadCartSummary();
});
window.addEventListener('pageshow', event => { if (event.persisted) updateSquadCartSummary(); });

if (!customElements.get('scg-photo-gallery')) {
  customElements.define('scg-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.current = 0;
      this.filter = 'all';
      this.addEventListener('click', event => {
        const filterButton = event.target.closest('[data-filter]');
        if (filterButton) {
          this.filter = filterButton.dataset.filter;
          this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filterButton)));
          this.querySelectorAll('.scg-gallery-card').forEach(card => { card.hidden = this.filter !== 'all' && card.dataset.category !== this.filter; });
        }
        const photo = event.target.closest('[data-photo-open]');
        if (photo) { this.photos = this.visiblePhotos(); this.current = this.photos.indexOf(photo); this.showPhoto(); this.dialog.showModal(); }
        if (event.target.closest('[data-photo-close]')) this.dialog.close();
        if (event.target.closest('[data-photo-prev]')) this.move(-1);
        if (event.target.closest('[data-photo-next]')) this.move(1);
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.move(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
      }, options);
    }
    visiblePhotos() { return Array.from(this.querySelectorAll('.scg-gallery-card:not([hidden]) [data-photo-open]')); }
    move(direction) { this.current = (this.current + direction + this.photos.length) % this.photos.length; this.showPhoto(); }
    showPhoto() {
      const photo = this.photos[this.current];
      const image = this.querySelector('[data-photo-image]');
      image.src = photo.dataset.full;
      image.alt = photo.dataset.caption;
      this.querySelector('[data-photo-caption]').textContent = photo.dataset.caption;
      this.querySelector('[data-photo-source]').href = photo.dataset.source;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
